<template>
    <footer v-if="shouldShowNavbar == true">
        <nav class="bottom-nav fixed-bottom">
            <div class="nav-inner">
                    <div class="navbar-button">
                        <router-link to="/" exact title="Home">
                            <ion-icon name="home-outline"></ion-icon>
                        </router-link>
                    </div>
                    <div class="navbar-button">
                        <router-link to="/profile" title="Profile">
                            <ion-icon name="person-circle-outline"></ion-icon>
                        </router-link>
                    </div>
                    <div class="navbar-button" v-if="isAdmin">
                        <router-link to="/admin" title="Admin">
                            <ion-icon name="hammer-outline"></ion-icon>
                        </router-link>
                    </div>
                    <div class="navbar-button">
                        <router-link to="/logout" title="Logout">
                            <ion-icon name="log-out-outline"></ion-icon>
                        </router-link>
                    </div>
            </div>
        </nav>

            
    </footer>
</template>

<script>
    import Vue from 'vue';
    import AdminService from '@/services/admin.service.js'

    Vue.config.ignoredElements = ['ion-icon']

    export default {
        name: 'MainFooter',

        data () {
            return {
                isAdmin: false,
            }
        },

        computed: {
            shouldShowNavbar() {
                const noNavbarPages = ['/login', '/reset'];
                return !noNavbarPages.some(page => this.$route.path.startsWith(page));
            }
        },

        mounted: function () {
            this.$root.$on('FooterUpdateEvent', () => {
                this.checkIfAdmin();
            })

            this.checkIfAdmin();
        },

        methods: {
            async checkIfAdmin() {
                this.isAdmin = await AdminService.isAdmin();
            },

        }

    }
</script>

<style scoped>
    .bottom-nav {
        display: flex;
        justify-content: center;
        padding: 0.75rem 1rem 1rem;
        background: transparent;
    }

    .nav-inner {
        display: flex;
        gap: 0.55rem;
        padding: 0.55rem;
        border: 2px solid var(--ss-line);
        border-radius: 999px;
        background: rgba(255, 253, 244, 0.92);
        box-shadow: 0 10px 0 rgba(22, 20, 15, 0.13), 0 20px 38px rgba(22, 20, 15, 0.18);
        backdrop-filter: blur(12px);
    }

    .navbar-button a {
        width: 3.15rem;
        height: 3.15rem;
        display: grid;
        place-items: center;
        border: 2px solid transparent;
        border-radius: 999px;
        background: transparent;
        transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;
    }

    .navbar-button a:hover {
        transform: translateY(-1px);
        border-color: var(--ss-line);
        background: #fff4c2;
    }

    ion-icon {
        color: var(--ss-ink);
        font-size: 1.65rem;
    }

    .router-link-active {
        border-color: var(--ss-line) !important;
        background: var(--ss-green) !important;
        box-shadow: 0 4px 0 var(--ss-line);
    }

    .router-link-active ion-icon {
        color: var(--ss-ink) !important;
    }
</style>
